import { render, staticRenderFns } from "./ExamSocialUnit.vue?vue&type=template&id=10e84ba3&scoped=true"
import script from "./ExamSocialUnit.vue?vue&type=script&lang=js"
export * from "./ExamSocialUnit.vue?vue&type=script&lang=js"
import style0 from "./ExamSocialUnit.vue?vue&type=style&index=0&id=10e84ba3&prod&lang=css"
import style1 from "./ExamSocialUnit.vue?vue&type=style&index=1&id=10e84ba3&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10e84ba3",
  null
  
)

export default component.exports